import { Menu, Transition } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"

import { signOut, useSession } from "next-auth/react"
import { Fragment } from "react"

import navigation from "@/data/navigation.json"
import ProfileNav from "./profileNav"


function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export default function LinksNavMobile() {
    const session = useSession()

    return (
        <>
            {navigation.map((item) => (
                <Menu as="div" key={item.name} className="relative ml-3 flex-row justify-center">
                    {/* <div className="flex"> */}
                    {/* <a key={item.name} href={item.href}
                            className="block py-2 pl-3 pr-4 text-base font-bold text-gray-800 border-l-4 border-transparent  hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 "
                        >
                            {item.name}
                        </a> */}
                    {/* <Menu.Button className="relative flex pt-3 -left-2 ml-0 "> */}
                    <Menu.Button className={classNames(
                        item.current ? ' text-black-300' : 'text-black-300  hover:text-black-300',
                        'flex pb-2 w-full justify-start px-3 font-bold fs-100'
                    )}>
                        <span>
                            {item.name}
                        </span>
                        <ChevronDownIcon className="w-6 h-6 pl-0 mt-1" aria-hidden="true" />
                        {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg> */}
                        {/* <ChevronDownIcon className={classNames(
                                item.current ? ' text-black-300' : 'text-black-300  hover:text-black-300',
                                'w-4 h-4 -left-5 -top-4'
                            )} aria-hidden="true" /> */}

                    </Menu.Button>
                    {/* </div> */}
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        {/* <Menu.Items className="right-0 z-10 mt-10 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"> */}
                        <Menu.Items className="z-10 w-full justify-start text-left">
                            {item.subitems.map((subitem: any) =>
                                <Menu.Item key={subitem.name}>
                                    {({ active }) => (
                                        <a
                                            href={subitem.href}
                                            className={classNames(active ? 'bg-gray-100 mr-2 text-decoration-none' : '', 'block px-4 py-2 text-xl text-gray-700 text-decoration-none')}
                                        >
                                            {subitem.name}
                                        </a>
                                    )}
                                </Menu.Item>
                            )}
                        </Menu.Items>
                    </Transition>
                </Menu>
            ))}
            {session.status === "authenticated" ?
                <div></div>
                :
                <a className="flex justify-center uppercase bg-amber-300 w-[150px] mt-2 px-3 mx-4 py-3 rounded font-medium text-lg"
                    href="/account/login">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 pt-1">
                        <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
                    </svg>
                    &nbsp;Member Login
                </a>
            }
        </>
    )
}